import type { ReactNode } from 'react';

export const symbol_switch_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M740-880q24 0 42 18t18 42v680q0 24-18 42t-42 18H220q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h520Zm0 60H220v680h520v-680ZM605-675H356q-12.75 0-21.37 8.62Q326-657.75 326-645v329q0 12.75 8.63 21.37Q343.25-286 356-286h249q12.75 0 21.38-8.63Q635-303.25 635-316v-329q0-12.75-8.62-21.38Q617.75-675 605-675Zm-30 60v187H386v-187h189Zm-94.47 382q-8.46 0-14 5.53-5.53 5.54-5.53 14 0 8.47 5.53 14.47 5.54 6 14 6 8.47 0 14.47-6t6-14.47q0-8.46-6-14-6-5.53-14.47-5.53Zm0-535q-8.46 0-14 5.53-5.53 5.54-5.53 14 0 8.47 5.53 14.47 5.54 6 14 6 8.47 0 14.47-6t6-14.47q0-8.46-6-14-6-5.53-14.47-5.53ZM480-480Z"
		/>
	</svg>
);
